"use strict";
/**
 * Created on 06 23 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var commons_1 = require("../../core/commons");

var SupplierAgreementPricesRecalcInput_1 = require("../model/SupplierAgreementPricesRecalcInput");

var SupplierAgreementPricesRecalcInputConverter_1 = require("./SupplierAgreementPricesRecalcInputConverter");
/**
 * Implementation of {@link SupplierAgreementPricesRecalcInputConverter}.
 *
 * @author JMe
 */


var SupplierAgreementPricesRecalcInputConverterImpl =
/*#__PURE__*/
function (_SupplierAgreementPri) {
  _inherits(SupplierAgreementPricesRecalcInputConverterImpl, _SupplierAgreementPri);

  function SupplierAgreementPricesRecalcInputConverterImpl() {
    _classCallCheck(this, SupplierAgreementPricesRecalcInputConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementPricesRecalcInputConverterImpl).apply(this, arguments));
  }

  _createClass(SupplierAgreementPricesRecalcInputConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      // serialization should not be needed
      throw commons_1.UNIMPLEMENTED("SupplierAgreementPricesRecalcInputConverterImpl.toDocument");
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SupplierAgreementPricesRecalcInput_1.SupplierAgreementPricesRecalcInput(conversions.asObject(source, 'aId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'wId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'iId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'pId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'sId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'cId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'regPPrice', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'regPPriceNett', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'promoPPrice', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'promoPPricePlus', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'promoPFrom', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'lastPromoPurchaseUpdate', function (v) {
        return conversions.toDate(v);
      }));
    }
  }]);

  return SupplierAgreementPricesRecalcInputConverterImpl;
}(SupplierAgreementPricesRecalcInputConverter_1.SupplierAgreementPricesRecalcInputConverter);

exports.SupplierAgreementPricesRecalcInputConverterImpl = SupplierAgreementPricesRecalcInputConverterImpl;